import React, { useContext } from "react";
import ThemeContext from "~/contexts/ThemeContext";
import styles from "./LoyaltyEarnings.module.css";
import SettingsContext from "~/contexts/SettingsContext";
import OrderContext from "~/contexts/OrderContext";
import { uploadcareConfig } from "~/configs/uploadcareConfig";
import {
  formatIntCurrency,
  formatLoyaltyBalance,
} from "~/helpers/numberHelpers";
import AuthContext from "~/contexts/AuthContext";
import { brandConfig } from "~/configs/brandConfigs";
import { Brand } from "~/entities/brandEntities";
import TaxContext from "~/contexts/TaxContext";

const LoyaltyEarnings: React.FC = () => {
  const { template } = useContext(ThemeContext);
  const { orgSettings } = useContext(SettingsContext);
  const { orderSummary } = useContext(OrderContext);
  const { authenticatedUser } = useContext(AuthContext);
  const { currency } = useContext(TaxContext);

  const hasLoyalty = !!(
    authenticatedUser?.loyaltyBalance != null &&
    authenticatedUser.loyaltyCheckbox
  );

  // Styles
  const fontColor = template.cart.fontColour;
  // Texts
  const joinOurLoyaltyProgram = template.loyalty.text.joinOurLoyaltyProgram;

  if (hasLoyalty && !orderSummary.finalPriceIncTax) return null;

  const pointsEarned =
    currency && brandConfig.Brand === Brand.BURGER_FUEL
      ? formatIntCurrency(orderSummary.finalPriceIncTax, {
          ...currency,
          currencySymbol: "",
        })
      : formatLoyaltyBalance(orgSettings, orderSummary.finalPriceIncTax);

  return (
    <div className={styles.container}>
      {orgSettings?.loyaltySettings?.loyaltyIcon && (
        <img
          src={uploadcareConfig.getUrl(
            orgSettings?.loyaltySettings?.loyaltyIcon.fileId,
            orgSettings?.loyaltySettings?.loyaltyIcon.modifiers,
          )}
          alt={orgSettings?.loyaltySettings?.loyaltyIcon.fileName}
          className={styles.loyaltyIcon}
        />
      )}
      {orderSummary.finalPriceIncTax > 0 ? (
        <span className={styles.earningMessage}>
          {hasLoyalty ? "Y" : `${joinOurLoyaltyProgram}, y`}ou&apos;ll clock{" "}
          <b style={{ color: fontColor }}>
            {pointsEarned}{" "}
            {orgSettings?.loyaltySettings?.balanceUnitName ?? "balance"}
          </b>
        </span>
      ) : (
        !hasLoyalty && (
          <b className={styles.earningMessage}>{joinOurLoyaltyProgram}</b>
        )
      )}
    </div>
  );
};

export default LoyaltyEarnings;
